const resource = {
    resource_identifier_in_use: 'Die API-Kennung {{indicator}} wird bereits verwendet',
    cannot_delete_management_api: 'Kann das Logto-Management-API nicht löschen.',
    cannot_modify_management_api: 'Kann das Logto-Management-API nicht ändern.',
};
export default Object.freeze(resource);
